import { takeLatest, call, put, all } from 'redux-saga/effects';

// SERVICES
import { PATH_SGU_API } from 'services/rotasp/path';

// TYPES
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { ApiResponse, getApi } from 'services/rotasp/api';
import { Types, ConsultarStatusRequest } from './types';

// ACTIONS
import { consultarStatusSuccess, consultarStatusFailure } from './actions';

function* consultarStatus(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarStatusRequest } = request;

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as ConsultarStatusRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`status`,
		body,
	);

	if (response.status === 200) {
		yield put(consultarStatusSuccess(response));
	} else {
		yield put(consultarStatusFailure());
	}
}

export default all([takeLatest(Types.CONSULTAR_STATUS, consultarStatus)]);
